<template>
	<el-dialog :visible.sync="is_visible" :width="'30%'" @close="hide">
		<template slot="title">
			<div>
				<h3 class="mb-0 font-weight-500">{{ is_update ? 'Update Invoice Category' : 'Add Invoice Category' }}</h3>
			</div>
		</template>
		<b-form>
				<b-row>
						<!-- FIELD CHANNEL NAME -->
						<b-col cols="12" md="12">
								<b-form-group label="Type">
										<b-form-input
												v-model="formData.name"
												type="text"
												required
												></b-form-input>
								</b-form-group>
						</b-col>
						<b-col cols="12" md="12">
								<b-form-group label="Professional Services Details">
										<b-form-input
												v-model="formData.description"
												type="text"
												></b-form-input>
								</b-form-group>
						</b-col>
						<b-col cols="12" md="12">
								<b-form-group label="Percentage Formula">
										<b-form-input
												v-model="formData.percent"
												type="number"
												step="0.01"
												></b-form-input>
								</b-form-group>
						</b-col>
						<b-col cols="12" md="12">
								<b-form-group label="Default Value">
										<b-form-input
												v-model="formData.amount"
												type="number"
												step="0.01"
												></b-form-input>
								</b-form-group>
						</b-col>
						<b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
							<el-button type="primary"  @click="submit()" :loading="is_loading_btn">{{ is_update ? 'Save' : 'Create' }}</el-button>
						</b-col>
				</b-row>
		</b-form>
	</el-dialog>
</template>
<script>
import { Select, Option, Dialog, Button } from 'element-ui'
import { mapActions } from 'pinia'
import { useBillingStore } from '@/stores/billingStore'

export default {
	components: {
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Dialog.name]: Dialog,
	},    
	data() {
			return {
				is_visible: false,
				is_update: false,
				is_loading_btn: false,
				formData:{
					id:null,
					name: '',
					decription: '',
					percent: 0,
					amount: 0
				}
			}
	},
	methods:{
		...mapActions(useBillingStore, ['postInvoiceCategory', 'putInvoiceCategory']),
		show(item={}){
			if(!_gHlp.isEmpty(item)){
				this.formData = {...this.formData,...item};
				this.is_update = true;
			}else{
				this.formData = _gHlp.resetFormAttributes(this.formData);
				this.is_update = false;
			}
			this.is_visible = true
		},
		hide(){
			this.formData = _gHlp.resetFormAttributes(this.formData);
			this.is_update = false
			this.is_visible = false
			this.is_loading_btn = false
		},
		async submit(){
			this.is_loading_btn = true
			let resp = null;
			let params = {
				name: this.formData.name,
				description: this.formData.description,
				percent: this.formData.percent,
				amount: this.formData.amount,
			}
			if(this.is_update){
				resp = await this.putInvoiceCategory(this.formData.id,params)
				if(!_gHlp.isEmpty(resp)){
					_gNotif.notifySuccess('<b>Invoice Category:</b> - Successfully Updated.',10000,'success');
				}
			}else{
				resp = await this.postInvoiceCategory(params)
				if(!_gHlp.isEmpty(resp)){
					_gNotif.notifySuccess('<b>Invoice Category:</b> - Successfully Created.',10000,'success');
				}
			}
			if(!_gHlp.isEmpty(resp)){
				this.$emit('refresh', true)
				this.hide();
			}
		}
	}
}
</script>